import { memo } from 'react';
import { Alert, SpaceBetween } from '@amzn/awsui-components-core';

import constants from '../../common/constants';
import { useContentStatusBannersViewModel } from './ContentStatusBannersViewModel';

/** Status banners shown above the read-only content tabs: locked, finalizing, and author-editing notices. */
export const ContentStatusBannersView = memo(function ContentStatusBannersView() {
  const vm = useContentStatusBannersViewModel();

  if (!vm) return null;

  const hasBanner =
    vm.lockedByUserName !== undefined ||
    vm.isSystemLocked ||
    vm.isFinalizing ||
    vm.isAuthorEditingForBarRaiser ||
    vm.barRaiserWarning !== undefined ||
    vm.justPublished;
  if (!hasBanner) return null;

  return (
    <SpaceBetween size="s">
      {vm.justPublished && (
        <Alert type="success" dismissible onDismiss={vm.dismissJustPublished}>
          Your content is published. You are now viewing the published version.
        </Alert>
      )}
      {vm.isSystemLocked && <Alert type="info">{constants.SYSTEM_LOCK_BANNER}</Alert>}
      {vm.lockedByUserName !== undefined && (
        <Alert type="warning">
          {`This content is currently being edited by ${
            vm.lockedByUserName || 'another user'
          }. It will become available for editing and adding new inline comments when the user finishes their work.`}
        </Alert>
      )}
      {vm.isFinalizing && (
        <Alert type="info">
          This content is being finalized for publication. Some actions are unavailable until
          finalization completes.
        </Alert>
      )}
      {vm.isAuthorEditingForBarRaiser && (
        <Alert type="warning">
          You are currently unable to complete approval or add new inline comments because the
          author is editing this content.
        </Alert>
      )}
      {vm.barRaiserWarning === 'not-reviewed' && (
        <Alert type="warning" header="Notice">
          An APG bar raiser has not reviewed this content. Please use with caution.
        </Alert>
      )}
      {vm.barRaiserWarning === 'rejected' && (
        <Alert type="warning" header="Notice">
          An APG bar raiser has reviewed this content and requested updates. This content may
          contain inaccurate or incomplete information. Please use with caution.
        </Alert>
      )}
    </SpaceBetween>
  );
});
